/**
 * EPIs da empresa e seus C.A. (#551): rota plana `/company-epis`.
 */
import apiClient from './apiClient';
import type { CertificateInput, CompanyEpi } from '../types/companyEpi';

const BASE = '/company-epis';

class CompanyEpiService {
  async list(companyId: string): Promise<CompanyEpi[]> {
    const response = await apiClient.get<CompanyEpi[]>(`${BASE}?companyId=${companyId}`);
    return response.data ?? [];
  }

  async add(companyId: string, epiId: string): Promise<void> {
    await apiClient.post(BASE, { companyId, epiId });
  }

  /** `null` devolve a orientação do cadastro-base. */
  async updateOrientation(id: string, orientacaoDeUso: string | null): Promise<void> {
    await apiClient.put(`${BASE}/${id}`, { orientacaoDeUso });
  }

  async remove(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  }

  async addCertificate(id: string, data: CertificateInput): Promise<void> {
    await apiClient.post(`${BASE}/${id}/certificates`, data);
  }

  async updateCertificate(id: string, certificateId: string, data: CertificateInput): Promise<void> {
    await apiClient.put(`${BASE}/${id}/certificates/${certificateId}`, data);
  }

  async removeCertificate(id: string, certificateId: string): Promise<void> {
    await apiClient.delete(`${BASE}/${id}/certificates/${certificateId}`);
  }
}

export const companyEpiService = new CompanyEpiService();
export default companyEpiService;
